import {createSlice} from '@reduxjs/toolkit'
import {FlowStatus} from '../../pages/UserPages/Flow/WorkFlow/FlowTypes'

const initialState = {
  draft: {
    name: '',
    nodes: [],
    edges: [],
    status: FlowStatus.ACTIVE,
  },
  flowName: '',
}

const FlowDraftSlice = createSlice({
  name: 'flowDraft',
  initialState,
  reducers: {
    setFlowDraft: (state, {payload}) => {
      state.draft = payload
      state.flowName = payload.name
    },
    clearFlowDraft: (state) => {
      state.draft = initialState.draft
      state.flowName = ''
    },
    setFlowName: (state, {payload}) => {
      state.flowName = payload
      state.draft.name = payload
    },
  },
})

export const {setFlowDraft, clearFlowDraft, setFlowName} = FlowDraftSlice.actions
export default FlowDraftSlice.reducer
